import Box from "@mui/material/Box";
import Icon from "../../../../shared/ui/Icon";
import Typography from "@mui/material/Typography";
import React from "react";

const FormErrorMessage = ({message} : {message: string}) => (
    <Box display="flex" alignItems="flex-start" mt={0.5} mr={{ xs: 0, md: 1 }}>
        <Box color="error.main">
            <Icon icon="circle-exclamation" fixedWidth={true} sx={{ fontSize: "1rem" }} />
        </Box>
        <Box flexGrow={1} mt={0.25}>
            <Typography variant="body2" color="error.main">
                {message}
            </Typography>
        </Box>
    </Box>
);

export default FormErrorMessage;